import { Directive, OnInit, TemplateRef } from '@angular/core';
import { BoschUiDialog } from '../bosch-ui-dialog.service';

@Directive({
  selector: '[boschUiDialogBody]',
  standalone: true,
})
export class BoschUiDialogBodyDirective implements OnInit {
  constructor(private template: TemplateRef<unknown>, private dialogService: BoschUiDialog) {}

  ngOnInit(): void {
    const dialog = this.dialogService.dialogRef?.instance;
    if (dialog && dialog.body) {
      dialog.body.createEmbeddedView(this.template);
    }
  }
}
